import { render, staticRenderFns } from "./TerritoriesReport.vue?vue&type=template&id=08fc9b4a"
import script from "./TerritoriesReport.vue?vue&type=script&lang=js"
export * from "./TerritoriesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports